// Copyright (c) 2017 Comsearch, Inc., All rights reserved

export const ADD_ANTENNA_SETTINGS = 'ADD_ANTENNA_SETTINGS'
export const ADD_FREQUENCY_SETTINGS = 'ADD_FREQUENCY_SETTINGS'
export const ADD_REGULATORY_SETTINGS = 'ADD_REGULATORY_SETTINGS'
export const ADD_RADIO_SETTINGS = 'ADD_RADIO_SETTINGS'
